export default __webpack_public_path__ + "static/media/bg-image.e465dc85.jpg";